export default __webpack_public_path__ + "static/media/stripe-power-icon.02fe7bb3.svg";